export const sanctionsPrograms = [
    '561-Related',
    'BALKANS',
    'BELARUS',
    'BELARUS-EO14038',
    'BURMA-EO14014',
    'BURUNDI',
    'CAATSA - IRAN',
    'CAATSA - RUSSIA',
    'CAR',
    'CMIC-EO13959',
    'CUBA',
    'CYBER2',
    'DARFUR',
    'DPRK',
    'DPRK2',
    'DPRK3',
    'DPRK4',
    'DPRK-NKSPEA',
    'DRCONGO',
    'ELECTION-EO13848',
    'FSE-IR',
    'FSE-SY',
    'FTO',
    'GLOMAG',
    'HIFPAA',
    'HK-EO13936',
    'HRIT-IR',
    'HRIT-SY',
    'IFCA',
    'IFSR',
    'IRAN',
    'IRAN-CON-ARMS-EO',
    'IRAN-EO13846',
    'IRAN-EO13871',
    'IRAN-EO13876',
    'IRAN-EO13902',
    'IRAN-HR',
    'IRAN-TRA',
    'IRAQ2',
    'IRAQ3',
    'IRGC',
    'ISA',
    'LEBANON',
    'LIBYA2',
    'LIBYA3',
    'MAGNIT',
    'MALI-EO13882',
    'NICARAGUA',
    'NICARAGUA-NHRAA',
    'NPWMD',
    'NS-PLC',
    'PEESA',
    'PEESA-EO',
    'RUSSIA-EO14024',
    'SDGT',
    'SDNT',
    'SDNTK',
    'SOMALIA',
    'SOUTH SUDAN',
    'SYRIA',
    'SYRIA-CAESAR',
    'SYRIA-EO13894',
    'TCO',
    'UKRAINE-EO13660',
    'UKRAINE-EO13661',
    'UKRAINE-EO13662',
    'UKRAINE-EO13685',
    'VENEZUELA',
    'VENEZUELA-EO13850',
    'VENEZUELA-EO13884',
    'YEMEN',
    'ZIMBABWE',
];

export const sanctionsLists = [
    '',
    'Non-SDN',
    'SDN',
];



// WEBPACK FOOTER //
// ./app/constants/sancitons.js